"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.transformToAnalyticsEvent = exports.forwardAnalyticsEvent = exports.Name = void 0;
const Name = exports.Name = 'analytics';
const transformToAnalyticsEvent = event => {
  const detail = {
    originalEventType: event.type,
    originalEventDetail: event.detail
  };
  return new CustomEvent(Name, {
    detail
  });
};
exports.transformToAnalyticsEvent = transformToAnalyticsEvent;
const forwardAnalyticsEvent = event => {
  const forwardedEvent = transformToAnalyticsEvent(event);
  window.dispatchEvent(forwardedEvent);
};
exports.forwardAnalyticsEvent = forwardAnalyticsEvent;
//# sourceMappingURL=index.js.map